import {create} from "canvas-confetti";
import Utils from "./utils";

let confettiCanvas = document.getElementById("success-confetti-canvas");
const confetti = (confettiCanvas != null) ? create(confettiCanvas, {resize: true, useWorker: true}) : null;

function show(element) {
    Utils.removeClass(element, "hide");
    Utils.addClass(element, "show");
}

function hide(element) {
    Utils.removeClass(element, "show");
    Utils.addClass(element, "hide");
}

function showDates(num) {
    let dates = document.getElementsByClassName("dates-display");
    for (let i = 0; i < dates.length; i++) {
        let date = dates[i];
        if (date.dataset.num == num) {
            show(date);
        } else {
            hide(date);
        }
    }
    let buttons = document.getElementsByClassName("select-date-button");
    for (let i = 0; i < buttons.length; i++) {
        let b = buttons[i];
        if (b.dataset.num == num) {
            Utils.addClass(b, "selected");
            if (Utils.hasClass(b, "closed")) {
                hide(document.getElementById("form-date-register-button-container"));
            } else {
                show(document.getElementById("form-date-register-button-container"));
            }
        } else {
            Utils.removeClass(b, "selected");
        }
    }
    // document.getElementById("form-event-registration-field-series").value = num;
    document.getElementsByName("series")[0].value = num;
}

function hideForms() {
    let backdrop = document.getElementById("backdrop");
    if (backdrop) hide(backdrop);
    let successForm = document.getElementById("form-registration-successful");
    if (successForm) successForm.remove();
    let disclaimerForm = document.getElementById("form-disclaimer");
    if (disclaimerForm) hide(disclaimerForm);
}

let colors = ['#2f92c5', '#165e91', '#eeba36', '#fff'];
let end;
function successConfetti() {
    end = Date.now() + 0.5*1000;
    fireConfetti();

    setTimeout(() => confetti({
        colors: colors,
        particleCount: 20,
        spread: 360,
        startVelocity: 30,
        origin: { x: 0.5, y: 0.2},
    }), 1000);
}
function fireConfetti() {
    // right
    confetti({
        spread: 55,
        origin: { x: 0.6, y: 0.6 },
        angle: 40 + Math.random()*20,
        particleCount: 4,
        colors: colors,
        drift: Math.random()-0.5,
        scalar: Math.random() + 0.5,
        gravity: Math.random()*0.5 + 0.75,
        startVelocity: Math.random()*20+35,
        disableForReducedMotion: true,
    });
    // left
    confetti({
        spread: 55,
        origin: { x: 0.4, y: 0.6 },
        angle: 120 + Math.random()*10,
        particleCount: 4,
        colors: colors,
        drift: Math.random()-0.5,
        scalar: Math.random() + 0.5,
        gravity: Math.random()*0.5 + 0.75,
        startVelocity: Math.random()*20+35,
        disableForReducedMotion: true,
    });
    if (Date.now() < end) requestAnimationFrame(fireConfetti);
}

function isElement(o){
    return (
        typeof HTMLElement === "object" ? o instanceof HTMLElement : //DOM2
            o && typeof o === "object" && o.nodeType === 1 && typeof o.nodeName==="string"
    );
}

function getInputThatMatchesName(elementsArray, name) {
    for (let i = 0; i < elementsArray.length; i++) {
        if (elementsArray[i].name === name) {
            return elementsArray[i];
        }
    }
}

function setupDisclaimer() {
    let disclaimer = document.getElementById("form-disclaimer");
    let cookie = disclaimer.dataset.cookie;

    let button = document.getElementById('form-date-register-button');
    button.setAttribute('type', 'button');
    button.onclick = function () {
        show(document.getElementById("backdrop"));
        show(disclaimer);
    };
    document.getElementById('form-disclaimer-cancel-button').onclick = function() {
        if (cookie) setCookie(cookie, 'visited', 90);
        hideForms();
    };
    let continueLink = null;
    let continueButton = document.getElementById('form-disclaimer-continue-button');
    continueButton.onclick = () => {
        if (cookie) setCookie(cookie, 'visited', 90);
        if (continueLink !== null) {
            window.location.replace(continueLink);
        }
    };
    document.querySelectorAll('.form-disclaimer-option input').forEach((element) => {
        continueButton.disabled = true;
        element.onclick = () => {
            continueButton.disabled = false;

            let link = element.dataset.link;
            if (link === "continue") {
                continueLink = null;
                continueButton.setAttribute('type', 'submit');
            } else {
                continueLink = link;
                continueButton.setAttribute('type', 'button');
            }
        };
    });
}

const setCookie = (name, value, days = 7, path = '/') => {
    const expires = new Date(Date.now() + days * 864e5).toUTCString()
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=' + path
}

const getCookie = (name) => {
    return document.cookie.split('; ').reduce((r, v) => {
        const parts = v.split('=')
        return parts[0] === name ? decodeURIComponent(parts[1]) : r
    }, '')
}

const deleteCookie = (name, path) => {
    setCookie(name, '', -1, path)
}

(function() {
    let dates = document.getElementsByClassName("dates-display");
    if (dates.length === 0) return;
    for (let i = 0; i < dates.length; i++) {
        let date = dates[i];
        date.style="height:" + date.clientHeight + "px";
        hide(date);
    }

    let buttons = document.getElementsByClassName("select-date-button");
    for (let i = 0; i < buttons.length; i++) {
        let button = buttons[i];
        button.onclick = function() {
            showDates(button.dataset.num);
        }
        if (Utils.hasClass(button, "active")) {
            showDates(button.dataset.num);
        }
    }

    let backdrop = document.getElementById("backdrop");
    if (backdrop != null) backdrop.onclick = hideForms;

    let successCloseButton = document.getElementById("form-registration-successful-close-button");
    if (successCloseButton != null) successCloseButton.onclick = hideForms;

    let disclaimer = document.getElementById('form-disclaimer');

    if (disclaimer != null) {
        if (disclaimer.dataset.cookie) {
            if (!getCookie(disclaimer.dataset.cookie)) {
                setupDisclaimer();
            }
        } else {
            setupDisclaimer();
        }
    }

    if (document.getElementById("form-registration-successful")) {
        successConfetti();

        // Set the URL to not include the success state
        let refresh = window.location.protocol + "//" + window.location.host + window.location.pathname;
        window.history.pushState({ path: refresh }, '', refresh);
    }
})();
